@switch (toast.severity) {
    @case ('success') {
        <div
            class="flex flex-col relative gap-3 items-start p-6 shadow-[0_0_16px_0_rgba(0,0,0,0.25)] rounded-2xl min-w-[300px] max-w-[500px] pointer-events-auto bg-[var(--pax-toast-success-bg)] overflow-hidden"
        >
            <div class="flex flex-row gap-2">
                <div class="w-10 h-10 bg-[var(--pax-toast-success-icon-bg)] rounded-sm flex items-center justify-center">
                    <lucide-icon name="check" class="text-[var(--pax-toast-success-icon-color)]" [size]="24" strokeWidth="2"></lucide-icon>
                </div>
                @if (toast.summary) {
                    <h3 [innerHTML]="toast.summary" class="text-heading-s self-center text-[var(--pax-toast-success-text)]"></h3>
                }
            </div>
            <div class="flex-1">
                <p [innerHTML]="toast.detail" class="text-paragraph-s text-[var(--pax-toast-text-color)]"></p>
            </div>
            <ng-container [ngTemplateOutlet]="closeButton"></ng-container>
            <ng-container [ngTemplateOutlet]="progressBar"></ng-container>
        </div>
    }
    @case ('error') {
        <div
            class="flex flex-col relative gap-3 items-start p-6 shadow-[0_0_16px_0_rgba(0,0,0,0.25)] rounded-2xl min-w-[300px] max-w-[500px] pointer-events-auto bg-[var(--pax-toast-error-bg)] overflow-hidden"
        >
            <div class="flex flex-row gap-2">
                <div class="w-10 h-10 bg-[var(--pax-toast-error-icon-bg)] rounded-sm flex items-center justify-center">
                    <lucide-icon name="circle-x" class="text-[var(--pax-toast-error-icon-color)]" [size]="24" strokeWidth="2"></lucide-icon>
                </div>
                @if (toast.summary) {
                    <h3 [innerHTML]="toast.summary" class="text-heading-s self-center text-[var(--pax-toast-error-text)]"></h3>
                }
            </div>
            <div class="flex-1">
                <p [innerHTML]="toast.detail" class="text-paragraph-s text-[var(--pax-toast-text-color)]"></p>
            </div>
            <ng-container [ngTemplateOutlet]="closeButton"></ng-container>
            <ng-container [ngTemplateOutlet]="progressBar"></ng-container>
        </div>
    }
    @case ('warn') {
        <div
            class="flex flex-col relative gap-3 items-start p-6 shadow-[0_0_16px_0_rgba(0,0,0,0.25)] rounded-2xl min-w-[300px] max-w-[500px] pointer-events-auto bg-[var(--pax-toast-warn-bg)] overflow-hidden"
        >
            <div class="flex flex-row gap-2">
                <div class="w-10 h-10 bg-[var(--pax-toast-warn-icon-bg)] rounded-sm flex items-center justify-center">
                    <lucide-icon name="circle-alert" class="text-[var(--pax-toast-warn-icon-color)]" [size]="24" strokeWidth="2"></lucide-icon>
                </div>
                @if (toast.summary) {
                    <h3 [innerHTML]="toast.summary" class="text-heading-s self-center text-[var(--pax-toast-warn-text)]"></h3>
                }
            </div>
            <div class="flex-1">
                <p [innerHTML]="toast.detail" class="text-paragraph-s text-[var(--pax-toast-text-color)]"></p>
            </div>
            <ng-container [ngTemplateOutlet]="closeButton"></ng-container>
            <ng-container [ngTemplateOutlet]="progressBar"></ng-container>
        </div>
    }
    @case ('info') {
        <div
            class="flex flex-col relative gap-3 items-start p-6 shadow-[0_0_16px_0_rgba(0,0,0,0.25)] rounded-2xl min-w-[300px] max-w-[500px] pointer-events-auto bg-[var(--pax-toast-info-bg)] overflow-hidden"
        >
            <div class="flex flex-row gap-2">
                <div class="w-10 h-10 bg-[var(--pax-toast-info-icon-bg)] rounded-sm flex items-center justify-center">
                    <lucide-icon name="info" class="text-[var(--pax-toast-info-icon-color)]" [size]="24" strokeWidth="2"></lucide-icon>
                </div>
                @if (toast.summary) {
                    <h3 [innerHTML]="toast.summary" class="text-heading-s self-center text-[var(--pax-toast-info-text)]"></h3>
                }
            </div>
            <div class="flex-1">
                <p [innerHTML]="toast.detail" class="text-paragraph-s text-[var(--pax-toast-text-color)]"></p>
            </div>
            <ng-container [ngTemplateOutlet]="closeButton"></ng-container>
            <ng-container [ngTemplateOutlet]="progressBar"></ng-container>
        </div>
    }
}

<ng-template #closeButton>
    @if (toast.options?.closable) {
        <button
            (click)="closeToast.emit(toast.id!)"
            class="absolute top-3 right-3 text-[var(--pax-toast-close-button-color)] hover:bg-[var(--pax-toast-close-button-hover-bg)] p-1 rounded-full transition-colors"
        >
            <lucide-icon name="x" [size]="20"></lucide-icon>
        </button>
    }
</ng-template>

<ng-template #progressBar>
    @if (toast.options?.progressBar && !toast.options?.sticky) {
        <div
            class="absolute bottom-0 left-0 h-1 w-full bg-[var(--pax-toast-progress-bar-color)] opacity-30"
            [@progressBar]="{
                value: progressBarState,
                params: {
                    life: toast.options?.life,
                },
            }"
        ></div>
    }
</ng-template>

<div class="w-full min-w-[200px] max-w-[400px] break-words">
    <!-- ... existing toast content ... -->
</div>
